module.exports = __webpack_public_path__ + "98df57f053d6ec4a7c0b666fb332a7b1.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/feet/rollerskates-yellow.png
// module id = 2534
// module chunks = 0